function px(value) {
  return typeof value === "number" && !(isNaN(value) || value === Infinity || value === -Infinity) ? value + "px" : "";
}
export {
  px
};
//# sourceMappingURL=px.js.map
